export enum SocialRouteTypeEnum {
    themeManagement,
    postFeed,
    analytics,
    archive,
    archiveAnalytics,
    archivePostFeed,
}
